import styled from "styled-components";
import { variant } from "styled-system";

const MagazineBlockItemDetailsItem = styled.li`
  display: inline-block;
  font-size: 12px;
  line-height: 20px;
  font-feature-settings: "pnum" on, "onum" on;
  &:not(:last-of-type) {
    &:after {
      margin-left: 7px;
      margin-right: 7px;
      font-size: 14px;
      content: "|";
      ${variant({
        variants: {
          light: {
            color: "panelSecondary",
          },
          grey: {
            color: "headlinesSecondary",
          },
        },
      })};
    }
  }

  &:not(:first-of-type) {
    text-transform: uppercase;
  }
`;

MagazineBlockItemDetailsItem.defaultProps = {
  lineHeight: 1,
  color: "headlinesSecondary",
};

export { MagazineBlockItemDetailsItem };
